import Link from "next/link";
import PropTypes from "prop-types";
import { useTranslation, Trans } from "next-i18next";
import '../styles/_home-tab-blog.module.scss';

const ProductResources = ({resources}) => {
    const { t } = useTranslation("common");
    // Ensure resources is always an array
    const resourcesArray = Array.isArray(resources) ? resources : []
    return <>
        <section className={'home_tab_blog'}>
            <div className={'container'}>

                <div className="d-flex">
                    <div className="left-block">
                        <h2>
                            <Trans
                                ns="home"
                                i18nKey="handpicked.title"
                                components={{
                                    highlight: <span className="text-gradient" />,
                                }}
                            />
                        </h2>
                    </div>
                    <div className="right-block">
                        {(resourcesArray.length > 0 ? resourcesArray.slice(0, 3).map((resource, index) => {
                            return <Link prefetch={false} href={resource.link}><div className={'in-card'} key={index}>
                                <div className={"category-parrent d-flex"} ><div className="in-flex"><div className={`category ${resource.category}`}>{resource.category}</div> <div className={`category read-time`}>{resource.readingTime} mins read</div></div> <p className="author-name">{resource.author}</p></div>
                                <p>{resource.title}</p>
                            </div></Link>
                        }) : <h4>{t('blogHome.cta.comingSoon')}</h4>)}
                    </div>
                </div>

            </div>
        </section>
    </>
}
ProductResources.defaultProps = {
    resources: [],
    title: "Related Resources"
}
ProductResources.propTypes = {
    resources: PropTypes.array.isRequired,
    title: PropTypes.string
}

export default ProductResources;